export default __webpack_public_path__ + "static/media/help--download-qr.562811f9.png";